import { render, staticRenderFns } from "./dictionaryModal.vue?vue&type=template&id=3114503e&scoped=true"
import script from "./dictionaryModal.vue?vue&type=script&lang=js"
export * from "./dictionaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3114503e",
  null
  
)

export default component.exports